module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-result-wrapper card",
    on: {
      "click": function($event) {
        _vm.onClickItem(_vm.item)
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.item.formatted_address))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57c162dc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./Resources/Private/JavaScript/components/searchWidget/placeResultsTemplate.vue
// module id = 110
// module chunks = 0